import React from 'react';
import '../../assets/css/tiles.css';

export default class Tiles extends React.Component {
    constructor(props) {
        super(props);
    }

    
    
   
    render() {
        if(this.props.Items.length > 0 && !this.props.isMobile) {
            return (
                    <div className="article-list">
                        {/* Header for mobile UI */}
                        {/* <div className="article-list_header-mobile">{MobileHeader}</div>    */}
                        <ul key="tiles" className="tiny-block-grid-2  margin-all-zero" >
                            {
                            this.props.Items.map((item, index) => {
                                return <li key={index} data-item-index={index}  data-constructscid={item.heading} aria-label={item.heading}   data-sclintrackid={item.sclinktrackid} data-metrics={item.savemetricksId} className="article-list_item m_width" onClick={(e)=>this.props.onTileClick(e,index,this.props.currentTabid)} onKeyPress ={(e,value=this.props.onTileClick)=>{  return e.key=='Enter'? value(e,index,this.props.currentTabid): null}}>
                                    <h3 tabIndex = "0" role="button"  data-constructscid={item.heading} className="article-list_header" onClick={(e)=>this.props.onTileClick(e,index,this.props.currentTabid)} onKeyPress ={(e,value=this.props.onTileClick)=>{  return e.key=='Enter'? value(e,index,this.props.currentTabid): null}}> {item.heading} </h3>
                                    <div className="article-list_content"> {item.desc}  </div>
                                </li>
                            })
                            }
                        </ul>
                    </div>
                )
            } else if(this.props.Items.length > 0) {
                return(
                    <div className="article-list">
                        <div className="article-list_header-mobile">
                            { this.props.MobileHeader + " Solutions"}
                        </div>
                        <ul className="tiny-block-grid-2  margin-all-zero">
                        {
                            this.props.Items.map((item, index) => { 
                                return <li key={index} data-item-index={index} data-constructscid={item.heading} data-sclintrackid={item.sclinktrackid} data-metrics={item.savemetricksId} aria-haspopup={true}  className="article-list_item m_width" onClick={(e)=>this.props.onTileClick(e,index,this.props.currentTabid)}>
                                    <h4 tabIndex="0" className="article-list_header"> {item.heading} </h4>
                                </li>
                            })
                        }
                        </ul>
                    </div>
                )
            } else {
                return null;
            }
    }
}





// WEBPACK FOOTER //
// ./src/components/modules/Tiles.js